import { secureApi } from './secureApi';

// Secure API wrapper functions
export const getConfig = async (agent: string) => {
  return await secureApi.getConfig(agent);
};

export const sendMessageToAurora = async (
  userMessage: string,
  sessionId: string,
  agent: string,
  imageUrls: string[],
  videoUrls?: string[],
  websocketId?: string
) => {
  return await secureApi.sendMessageToAurora(
    userMessage,
    sessionId,
    agent,
    imageUrls,
    videoUrls,
    websocketId
  );
};

export const sendMessageToAuroraStreamingVoice = async (
  userMessage: string,
  sessionId: string,
  agent: string,
  imageUrls: string[],
  videoUrls?: string[],
  updateChat?: (partialMessage: string, isFinal: boolean) => void
) => {
  return await secureApi.sendMessageToAuroraStreaming(
    userMessage,
    sessionId,
    agent,
    imageUrls,
    videoUrls,
    updateChat
  );
};

export const sendMessageToAuroraStreaming = async (
  userMessage: string,
  sessionId: string,
  agent: string,
  imageUrls: string[],
  videoUrls?: string[],
  updateChat?: (partialMessage: string, isFinal: boolean) => void
) => {
  return await secureApi.sendMessageToAuroraStreaming(
    userMessage,
    sessionId,
    agent,
    imageUrls,
    videoUrls,
    updateChat
  );
};

export const getItineraryFromSessionId = async (sessionId: string) => {
  return await secureApi.getItineraryFromSessionId(sessionId);
};
